import { Component } from "react";
import { connect } from "react-redux";
import { closeNode } from "../actions";

export class Closed extends Component {
  componentDidMount() {
    const { dispatch, id, parent, root } = this.props;
    dispatch(closeNode(id, parent, root));
  }
  render() {
    return null;
  }
}

const mapStateToProps = state => ({
  client: state.client
});

export default connect(mapStateToProps)(Closed);



// WEBPACK FOOTER //
// ./src/containers/Closed.js